import { useI18n, LOCALES, type Locale } from '../i18n';

/**
 * Standalone language switcher used on the public legal pages
 * (/privacy, /terms, /account/delete). The landing-page Nav has its own
 * inline switcher; this component is for pages without a nav bar.
 *
 * `theme` picks the colour palette: 'dark' for the account-delete page
 * (espresso background) and 'light' for /privacy + /terms (cream
 * background). CSS rules live in styles/lang-switcher.css.
 */
export function LangSwitcher({ theme = 'light' }: { theme?: 'light' | 'dark' }) {
  const { locale, setLocale } = useI18n();
  return (
    <div
      class={`lang-switcher lang-switcher--${theme}`}
      role="group"
      aria-label="Language"
    >
      {LOCALES.map((l: Locale) => (
        <button
          key={l}
          type="button"
          class={l === locale ? 'is-active' : ''}
          aria-pressed={l === locale}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
